<template>
  <!-- VIP会员购买组件 -->
  <div class="vipBuy">
    <!-- 第一步--vip套餐选择-start -->
    <div class="vipTypeSelectLayout vipMemberLayout commomLayout" v-show="vipTypeSelectLayoutShow">
      <div class="content">
        <div class="layTop">
          <div class="layTitle">VIP会员</div>
          <a href="javascript:;" class="layoutCloseBtn" @click="cancelVipTypeSelect"><img src="@/common/img/close.png" /></a>
        </div>

        <!-- 欢乐一夏 -->
        <!-- <div class="notice" v-show="activity">
          <div>
            <div style="position: absolute;right: 20rpx;margin-top: 15rpx;"><img @click="activity=false" style="height: 25rpx;" src="../../common/img/phoneLoginClose.png"></div>
            <div class="imgClass" style="background-color: #e3a415;"><img style="width: 100%;height: 200rpx;" src="../../common/img/vipBuyBg.png"/></div>
            <div class="imgClass" style="margin-top: 23rpx;"><div style="width: 310rpx;"><img style="width: 260rpx;" src="../../common/img/1+1.png" /></div><div style="width: 357rpx;">【欢乐一“夏”】优惠活动进行中，进入微信移动端购买/续费更优惠<ul style="padding: 5rpx 20rpx;"><li>单月+送多1个月</li><li>半年+送多2个月</li><li>一年+送多3个月</li></ul>微信扫码前往移动端</div></div>
          </div>
        </div> -->
         <!-- 欢乐一夏end -->


        <div class="layCon">
          <div class="vipType">
            <ul>
              <li v-for="(item, index) of vipTypeList" v-bind:key="item.id" @click="selectVipType(item, index)" :class="{ active: index == vipTypeNo }">
                <a href="javascript:;">
                  <div class="vipName">
                    <p>
                      <span v-html="item.name"></span>
                      <span style="margin-left:10rpx;text-decoration: line-through;" v-if="item.originalPrice != null&&item.originalPrice != item.amount">原价：{{ item.originalPrice }}</span>
                    </p>
                    <p class="vipActualAmount" v-if="item.type == 1">升级金额{{ item.actualAmount }}元</p>
                  </div>
                </a>
              </li>
            </ul>
            <div class="cl_f"></div>
          </div>

          <!-- 选择多账号-start -->
          <div class="yearCountDiv buyCount" v-show="yearCountDivShow">
            <div class="userInput form-input">
              <div class="name">
                <em>*</em>
                <i class="yearCountName">{{ yearCountName }}</i>
                账号：
              </div>
              <div class="input"><input type="text" placeholder="输入整数" value="1" @input="getYearCount" v-model="yearCount" /></div>
              <div class="moneyCount" v-show="moneyCountShow">
                <span class="discountPrice">
                  <i class="yearCountName">{{ yearCountName }}</i>
                  金额：
                  <em class="singleMoney">{{ singleMoney }}</em>
                </span>
              </div>
            </div>
            <div class="buyTips">
              <p>
                1.
                <i class="yearCountName">购买</i>
                1~4个账号，价格=3999+1800*（N-1）；
              </p>
              <p>
                2.
                <i class="yearCountName">购买</i>
                5个账号及以上，价格=3999+1500*（N-1）。
              </p>
            </div>
          </div>
          <!-- 选择多账号-end -->

          <!-- 选择月数-start -->
          <div class="monthCountDiv buyCount" v-show="monthCountDivShow">
            <div class="userInput form-input">
              <div class="name">
                <em>*</em>
                购买月数：
              </div>
              <div class="input"><input type="text" id="monthCount" placeholder="输入整数" value="1" @input="getMonthCount" v-model="monthCount" /></div>
              <div class="moneyCount">
                <span class="discountPrice">
                  个月/
                  <em class="newMoney">{{ newMoney }}</em>
                </span>
                <span class="originalPrice" v-show="originalPriceShow">
                  原价：
                  <em class="oldMoney">{{ oldMoney }}</em>
                </span>
              </div>
            </div>
            <div class="buyTips">购买6个月及以上9折优惠；购买12个月及以上8折优惠。</div>
          </div>
          <!-- 选择月数-end -->

          <!-- 会员升级规则-start -->
          <div class="vipActualTips" v-show="vipActualTipsShow">
            <div class="title">会员升级说明</div>
            1.会员升级金额计算规则：新会员单价-（原会员单价/原会员总天数*原会员剩余天数）=会员升级价格；
            <br />
            2.会员有效期为自升级之日起一年，有效期内如有再次升级，则有效期变更为从升级之日起一年；
            <!-- <br />3.会员升级仅适用于年会员。 -->
            <br />
          </div>
          <!-- 会员升级规则-end -->

          <div class="vipMemberFrom">
            <!-- <form>
              <div class="form-input">
                <div class="name"><em>*</em>姓名：</div>
                <div class="inputDiv">
                  <el-input
                    placeholder="请填写姓名"
                    v-model="memberName"
                    :disabled="inputDisabled"
                  ></el-input>
                </div>
              </div>
              <div class="form-input">
                <div class="name"><em>*</em>手机号码：</div>
                <div class="inputDiv">
                  <el-input
                    placeholder="请填写手机号码"
                    v-model="memberPhone"
                    :disabled="inputDisabled"
                  ></el-input>
                </div>
              </div>
              <div class="form-input">
                <div class="name"><em>*</em>公司：</div>
                <div class="inputDiv">
                  <el-input
                    placeholder="请填写公司名称"
                    v-model="memberCompany"
                    :disabled="inputDisabled"
                  ></el-input>
                </div>
              </div>
            </form> -->
          </div>
          <div class="vipMemberTable">
            <!-- <div class="layTitle">
              <img src="../vipMember/img/vipMemberTitle.png" width="190rpx" />
            </div> -->
            <div :class="isActive == 0 ? 'vipTab' : 'vipTabActive vipTab'">
              <ul>
                <li v-for="(item, index) in vipTabData" v-bind:key="index" v-bind:class="{ active: index == isActive }" @click="clickVipTab(index)">
                  <div>
                    <img :src="item.img1" class="img1" />
                    <img :src="item.img2" class="img2" />
                    {{ item.name }}
                  </div>
                </li>
              </ul>
            </div>
            <div class="table">
              <div v-if="isActive == 0 ? true : false">
               <img src="./img/vip11.png" @click="fullimgboxShow = true" style="width: 100%;height: 100%;cursor: pointer;">
              </div>
              <div  v-if="isActive == 1 ? true : false">
                <img src="./img/vip22.png" @click="fullimgboxShow2 = true" style="width: 100%;height: 100%;cursor: pointer;">
              </div>
              </body>
              </html>

            </div>
            <!-- <div class="tips">
              <p>1.所有会员专属特权仅限于会员有效期内。</p>
              <p>2.每次推送条数最多为3000条。</p>
              <p>
                3.
                U享分可导出U学商情项目/中标数据，并扣除相应的U享分。导出项目数据，以项目为计数单位，1个项目=1U享分；导出中标数据，以中标企业为计数单位，1个企业=1U享分）；自下载之日起30日内可免费重复下载同一数据。
              </p>
              <p>3. U享分需在会员有效期内使用；会员过期后U享分不清零，可累加至下个会员有效期。</p>
              <p>
                4.客服电话：
                <a href="tel:18926288521 ">
                  <span class="servicePhone">18926288521</span> </a
                >（微信同号）
              </p>
            </div> -->
          </div>
        </div>
        <div class="layButton">
          <a href="javascript:;" class="submitBtn" @click="goVipPayWay">立即购买</a>
          <a href="javascript:;" class="cancelBtn" @click="cancelVipTypeSelect">取消</a>
        </div>
      </div>
      <div class="commomLayoutBg"></div>
    </div>
    <!-- 第一步--vip套餐选择-end -->

    <!-- 第二步--支付信息-start -->
    <div class="vipPayWayLayout vipMemberLayout commomLayout" v-show="vipPayWayLayoutShow">
      <div class="content">
        <div class="layTop">
          <div class="layTitle">支付信息</div>
          <a href="javascript:;" class="layoutCloseBtn" @click="cancelVipPayWay"><img src="@/common/img/close.png" /></a>
        </div>
        <div class="layCon">
          <div class="pageTabNav" v-show="pageTabNavShow">
            <el-tabs v-model="payWayActive" @tab-click="handleClick">
              <el-tab-pane label="微信支付" name="first"></el-tab-pane>
              <el-tab-pane label="银行转账" name="second"></el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="payWaySelect">
          <div class="wxPay" v-show="wxPayShow">
            <div class="ewmPay">
              <div class="money">
                使用手机微信扫描二维码支付
                <span>¥{{ wxPayMoney }}元</span>
              </div>
              <div class="ewmDiv">
                <!-- initQCode: vue实例中定义好的变量；size:Canvas的大小，二维码的大小-->
                <!-- 二维码的生成-start -->
                <div class="ewmImg" v-show="initQCode != null && initQCode != '' ? true : false"><qriously :value="initQCode" :size="165" /></div>
                <!-- 二维码的生成-end -->
                <div class="ewmTips">
                  <div class="ico"><img src="../vipMember/img/ewmIco.png" /></div>
                  <div class="ewmText">
                    <p>使用手机微信扫一扫</p>
                    <!-- <p>
                      距离二维码过期还有
                      <span>33分15秒</span>
                    </p>-->
                  </div>
                </div>
              </div>
            </div>
            <div class="ewmPayIco"><img src="../vipMember/img/ewmPayIco.png" /></div>
          </div>
          <!-- 微信支付-end -->

          <div class="bankTransfer" v-show="bankTransferShow">
            <!-- 支付凭证的审核进度-start -->
            <div class="imgUploadSuccess" v-show="imgUploadSuccessShow">您上传的支付凭在等待审核，我们会在2个工作日内完成审核，请耐心等待。</div>
            <!-- 待审核-end -->
            <div class="imgUploadFail" v-show="imgUploadFailShow">
              <div class="failDiv">审核不过通，请重新上传支付凭证提交审核。</div>
              <div class="failMsg">
                <div class="bgIco"><img src="../../common/img/reviewIco3.png" /></div>
                <div class="bg">
                  <p>原因：{{ imgUploadFailMsg }}。</p>
                </div>
              </div>
            </div>
            <!-- 审核不通过 -end -->
            <!-- 支付凭证的审核进度-end -->
            <div class="vipType">
              会员套餐：
              <span v-html="vipType"></span>
            </div>
            <div class="vipType" style="margin-top:-35rpx" v-show="vipMoneyShow">
              金额：
              <span>{{ vipMoney }}</span>
              元
            </div>
            <div class="bankAccountMsg">
              <div class="title">收款账户信息</div>
              <div class="accountMsg">
                <div class="accountName">
                  <div class="name">开户名称：</div>
                  <div class="msg">广东优壹科技有限公司</div>
                </div>
                <div class="accountBank">
                  <div class="name">开户银行：</div>
                  <div class="msg">招商银行股份有限公司广州开发区支行</div>
                </div>
                <div class="accountMember">
                  <div class="name">银行账号：</div>
                  <div class="msg">1209 0893 4810 401</div>
                </div>
                <div class="payVoucher">
                  <div class="name">支付凭证：</div>
                  <div class="upLoad">
                    <div class="inputDiv"><input :placeholder="payVoucherTips" /></div>
                    <el-upload
                      class="upload-demo"
                      :action="imgUploadUrl"
                      :on-change="handleChange"
                      :on-success="uploadSuccess"
                      :on-error="uploadError"
                      :file-list="imgList"
                      :with-credentials="true"
                    >
                      <el-button size="small" type="primary" v-show="uploadBtnShow">点击上传</el-button>
                    </el-upload>
                    <div class="tips">转账成功后，请上传银行转账凭证，以便账务核对</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="layButton" v-show="layButtonShow">
              <a href="javascript:;" class="submitBtn" @click="submitPay">确定</a>
              <a href="javascript:;" class="cancelBtn" @click="goMyOrder">{{ cancelBtnText }}</a>
            </div>
          </div>
          <!-- 银行转账-end -->
        </div>
      </div>
      <div class="commomLayoutBg"></div>
    </div>
    <!-- 第二步--支付信息-end -->

    <!-- 企业分析背景图-start -->
    <div class="companyAnalyzeBg" v-show="companyAnalyzeBgShow && false" @click="closeCompanyAnalyzeBg"><img src="../vipMember/img/companyAnalyzeBg1.png" /></div>
    <!-- 企业分析背景图-end -->

    <!-- 标讯分析背景图-start -->
    <div class="tenderAnalyzeBg" v-show="tenderAnalyzeBgShow && false" @click="closeTenderAnalyzeBg"><img src="../vipMember/img/tenderAnalyzeBg.png" /></div>
    <!-- 标讯分析背景图-end -->

    <div class="fullimgbox" v-if="fullimgboxShow">
      <div style="width: 88%;margin: 0 auto;text-align: center;position: relative;max-width: 1300px;">
        <img class="close" style="cursor: pointer;" @click="fullimgboxShow = false" src="@/common/img/close.png" />
        <img src="./img/vip11.png" class="fullimg">
      </div>
    </div>

    <div class="fullimgbox" v-if="fullimgboxShow2">
      <div style="width: 88%;margin: 0 auto;text-align: center;position: relative;max-width: 1300px;">
        <img class="close" style="cursor: pointer;" @click="fullimgboxShow2 = false" src="@/common/img/close.png" />
        <img src="./img/vip22.png" class="fullimg">
      </div>
    </div>

  </div>
</template>

<script>
// 引入图片
import img1 from '@/page/vipMember/img/vipTabIco1.png';
import img1On from '@/page/vipMember/img/vipTabIco1_on.png';
import img2 from '@/page/vipMember/img/vipTabIco2.png';
import img2On from '@/page/vipMember/img/vipTabIco2_on.png';
import axios from 'axios';
import '@/page/vipMember/css/vipMember.css'; //页面样式
//微信支付-二维码的生成-start
import Vue from 'vue';
import VueQriously from 'vue-qriously';
Vue.use(VueQriously);
//微信支付-二维码的生成-end
import { apiUrl } from '@/api/requestUrl';
import { cntextPath } from '@/api/requestUrl';
export default {
  name: 'vipBuy',
  data() {
    return {
      fullimgboxShow:false,
      fullimgboxShow2:false,

      activity:true,
      memberName: '',
      memberPhone: '',
      memberCompany: '',
      vipTypeList: [],
      payWayActive: 'first', //支付信息-默认为微信支付
      wxPayShow: true, //微信支付
      bankTransferShow: false, //银行转账
      imgList: [], //支付凭证
      vipTypeSelectLayoutShow: false, //vip会员弹窗
      vipPayWayLayoutShow: false, //支付信息弹窗
      pageTabNavShow: true, //支付信息-微信支付、银行转账切换导航的状态
      vipLevelId: '', //会员等级id（专业会员、高级会员……）
      vipTypeId: '', //会员类型id（月会员、年会员……）
      typeId: '', //会员套餐id,上面2个不要了,只要一个套餐id
      vipTypeNo: 0, //默认选择的vip类型-个人专业会员
      wxPayMoney: '', //微信支付-金额
      initQCode: '', //微信支付-二维码
      timeValState: false, //微信支付二维码请求的定时器
      vipType: '', //银行转账-vip套餐
      vipMoney: 0, //银行转账-升级金额
      vipMoneyShow: false,
      imgUploadUrl: '', //银行转账-图片上传链接
      imgUploadUuid: '', //银行转账-图片上传成功后返回的uuid
      imgUploadSuccessShow: false, //银行转账-支付凭证待审核提示是否显示
      imgUploadFailShow: false, //银行转账-支付凭证审核不通过提示是否显示
      imgUploadFailMsg: '', //银行转账-支付凭证审核不通过原因
      merberOrderId: '', //会员订单id--上传银行转账凭证时需要提交的订单id
      layButtonShow: true, //银行转账-操作按钮的显示状态（支付凭证上传成功后处于审核状态将该按钮隐藏）
      payVoucherTips: '请上传支付凭证图片',
      cancelBtnText: '稍后上传',
      companyAnalyzeBgShow: false, //企业分析背景图-非专业会员点击“企业分析”导航出现
      tenderAnalyzeBgShow: false, //标讯分析背景图-非专业会员点击“标讯分析”导航出现
      renewalFeeStatus: false, //是否为续费；false为正常的购买会员流程；true则为续费流程
      vipActualTipsShow: false, //升级金额是否显示
      inputDisabled: false, //input输入框是否禁止输入内容
      uploadBtnShow: true, //点击上传按钮是否显示
      vipTabData: [{ img1: img1, img2: img1On, name: '会员套餐' }, { img1: img2, img2: img2On, name: '会员权益' }],
      isActive: 0,
      yearCountDivShow: false, //选择多个账号
      monthCountDivShow: false, //选择多个月
      newMoney: 99, //购买月会员折后的价格
      oldMoney: 99, //购买月会员没折扣的价格
      moneyApi: 99, //从api中id==2替换此价格
      monthCount: 1, //购买月会员的个数
      originalPriceShow: false, //购买月会员的原价是否显示
      yearCountName: '购买',
      yearCount: 1, //购买年会员的个数
      singleMoney: 3999, //年会员金额
      singleMoneyApi: 3999, //从api member/listRenewSetMeal中id==9替换此价格
      equivalentMoney: 0, //年会员的升级金额
      buyVipType: '', //用户购买的会员类型
      moneyCountShow: true,
      isMoreYearCount: false, //判断3999会员是否可选择多个账号：true:3999年会员有多个账号选择,false没有
      vipMemberName: '' ,//会员套餐名字
      showType:16,//正式用16，测试用80 //test
    };
  },
  methods: {
    //会员专属特权选择
    clickVipTab(index) {
      this.isActive = index;
    },

    //判断是否为vip会员（包含移动端月会员）
    async isMemberVip() {
      var that = this;
      /* that.requestApi({
        method: 'get',
        url: '/api/member/isMember',
        then(data) {
          //判断3999会员是否可选择多个账号：true:3999年会员有多个账号选择,false没有
          if (data.standbyData != null) {
            that.isMoreYearCount = data.standbyData;
          } else {
            that.isMoreYearCount = true;
          }
          //0：非会员
          if (data.data == 0) {
            that.renewalFeeStatus = false; //是否为续费；false为正常的购买会员流程；true则为续费流程
            that.vipMoneyShow = false;
          } else {
            console.log()
            that.vipMoneyShow = true; //升级金额
          }
        }
      }); */
     let {data} = await axios({
          method: 'get',
          url: apiUrl + cntextPath + '/api/member/isMember',
      });
      //判断3999会员是否可选择多个账号：true:3999年会员有多个账号选择,false没有
      if (data.standbyData != null) {
        that.isMoreYearCount = data.standbyData;
      } else {
        that.isMoreYearCount = true;
      }
      //0：非会员
      if (data.data == 0) {
        that.renewalFeeStatus = false; //是否为续费；false为正常的购买会员流程；true则为续费流程
        that.vipMoneyShow = false;
      } else {
        that.renewalFeeStatus = true;
        that.vipMoneyShow = true; //升级金额
      }
      that.$emit('isMemberVip');
    },

    //vip会员-获取vip类型列表
    getVipTypeList: function() {
      var that = this;
      console.log('vip会员-获取vip类型列表renewalFeeStatus:' + that.renewalFeeStatus);

      //获取升级费用
      that.requestApi({
        method: 'get',
        url: '/api/member/equivalentMoney',
        then(data) {
          //0：非会员
          if (data.data != null) {
            if (data.data == 0) {
              that.equivalentMoney = 0; //年会员的升级金额
            } else {
              that.equivalentMoney = data.data; //年会员的升级金额
            }
          }
        }
      });

      //判断会员的类型
      that.requestApi({
        method: 'get',
        url: '/api/member/getMember',
        then(data) {
          //0：非会员
          if (data.data) {
            that.buyVipType = data.data.value;
            //判断已开通的会员类型
            if (that.buyVipType == '移动端月会员') {
              //月会员
              that.yearCountName = '升级';
              that.singleMoney = that.singleMoneyApi - that.equivalentMoney;
            } else if (that.buyVipType == '专业年会员') {
              //3999年会员
              that.yearCountName = '续费';
              that.singleMoney = that.singleMoneyApi;
            }
          }
        }
      });
      console.log(that.renewalFeeStatus,'that.renewalFeeStatus')
      //false为正常的购买会员流程；true则为续费流程
      if (that.renewalFeeStatus == false) {
        that.inputDisabled = false;
        that.requestApi({
          method: 'get',
          url: '/api/member/listMembers',
          data: {showType:that.showType},
          then(data) {
            if (data.data != null) {
              that.vipTypeList = data.data;
              that.vipTypeList.reverse();
              //用户不选择，则默认选择个人专业会员
              that.typeId = that.vipTypeList[that.vipTypeNo].id;
              that.vipType = that.vipTypeList[that.vipTypeNo].name; //会员套餐
              that.vipMemberName = that.vipTypeList[that.vipTypeNo].name; //会员套餐
              for (let i in data.data) {
                if (data.data[i].id == 9) {
                  that.singleMoneyApi = data.data[i].amount;
                }
                if (data.data[i].id == 2) {
                  that.oldMoney = data.data[i].amount;
                  that.newMoney = data.data[i].amount;
                  that.moneyApi = data.data[i].amount;
                }
              }
            }
          }
        });
      } else {
        that.inputDisabled = true; //续费会员禁止修改会员信息
        that.requestApi({
          method: 'get',
          url: '/api/member/listRenewSetMeal',
          data: {showType:that.showType},
          then(data) {
            //判断3999会员是否可选择多个账号：true:3999年会员有多个账号选择,false没有
            if (data.standbyData != null) {
              that.isMoreYearCount = data.standbyData;
            } else {
              that.isMoreYearCount = true;
            }
            if (data.data != null) {
              that.vipTypeList = data.data;
              that.vipTypeList.reverse();
              //用户不选择，则默认选择个人专业会员
              that.vipLevelId = that.vipTypeList[that.vipTypeNo].id;
              that.vipMemberName = that.vipTypeList[that.vipTypeNo].name; //会员套餐
              //type=1：升级专业会员；type=0：专业会员续费
              console.log('data.data.type:' + data.data[that.vipTypeNo].type);
              if (data.data[that.vipTypeNo].type == 1) {
                that.vipActualTipsShow = true;
              } else {
                that.vipActualTipsShow = false;
              }
              for (let i in data.data) {
                if (data.data[i].id == 9) {
                  that.singleMoneyApi = data.data[i].amount;
                }
                if (data.data[i].id == 2) {
                  that.oldMoney = data.data[i].amount;
                  that.newMoney = data.data[i].amount;
                  that.moneyApi = data.data[i].amount;
                }
              }
            }
          }
        });
      }
    },

    //vip会员-选择会员类型
    selectVipType: function(item, index) {
      var that = this;
      that.vipTypeNo = index;
      console.log('vip会员-选择会员类型renewalFeeStatus:' + that.renewalFeeStatus);
      //false为正常的购买会员流程；true则为续费流程
      if (that.renewalFeeStatus == false) {
        that.vipLevelId = item.levelId; //会员等级id（专业会员、高级会员……）
        that.vipTypeId = item.typeId; //会员类型id（月会员、年会员……）
        that.typeId = item.id;
      } else {
        that.vipLevelId = item.id;
      }
      console.log('vip会员-选择会员类型that.vipLevelId:' + that.vipLevelId);
      console.log('item.name:' + item.name);
      that.vipType = item.name; //会员套餐
      that.vipMemberName = item.name; //会员套餐
      if (item.id == 9) {
        //判断3999会员是否可选择多个账号：true:3999年会员有多个账号选择,false没有
        that.singleMoney = that.singleMoneyApi - that.equivalentMoney;
        if (that.isMoreYearCount == true) {
          that.yearCountDivShow = true;
          that.singleMoney = that.singleMoneyApi - that.equivalentMoney;
        } else {
          that.yearCountDivShow = false;
          that.yearCount = 1;
        }
        that.monthCountDivShow = false;
      } else if (item.id == 2) {
        that.monthCountDivShow = true;
        that.yearCountDivShow = false;
      } else {
        that.monthCountDivShow = false;
        that.yearCountDivShow = false;
      }
    },

    //购买多个年会员计算
    getYearCount: function() {
      var that = this;
      if (that.yearCount.length > 0) {
        that.moneyCountShow = true;
        if (that.monthCount % 1 !== 0) {
          that.$message({
            message: '请填写整数',
            type: 'warning'
          });
          that.yearCount = Math.round(that.yearCount);
        }
        var equivalentYearMoney = that.singleMoneyApi;
        if (parseInt(that.yearCount) < 1) {
          that.$message({
            message: '最小不能低于1个账号',
            type: 'warning'
          });
          that.yearCount = 1;
          //判断已开通的会员类型
          if (that.buyVipType == '移动端月会员') {
            //月会员
            that.yearCountName = '升级';
          } else if (that.buyVipType == '专业年会员') {
            //3999年会员
            that.yearCountName = '续费';
          }
          if (that.equivalentMoney > that.singleMoneyApi + parseInt((that.yearCount - 1) * 1800)) {
            that.singleMoney = 1;
          } else {
            if (parseInt(that.yearCount) == 1) {
              that.singleMoney = equivalentYearMoney + parseInt(that.yearCount - 1) * 1800;
              if (that.buyVipType == '移动端月会员') {
                that.singleMoney = equivalentYearMoney + parseInt(that.yearCount - 1) * 1800 - that.equivalentMoney;
              }
            } else {
              that.singleMoney = equivalentYearMoney + parseInt(that.yearCount - 1) * 1800 - that.equivalentMoney;
              console.log('that.singleMoney:', that.singleMoney);
            }
          }
        } else if (parseInt(that.yearCount) < 5) {
          //购买年会员账号数<5
          //判断已开通的会员类型
          if (that.buyVipType == '移动端月会员') {
            //月会员
            that.yearCountName = '升级';
          } else if (that.buyVipType == '专业年会员') {
            //3999年会员
            if (parseInt(that.yearCount) == 1) {
              that.yearCountName = '续费';
            } else {
              that.yearCountName = '升级';
            }
            console.log('that.yearCount', that.yearCount);
          }
          if (that.equivalentMoney > that.singleMoneyApi + parseInt((that.yearCount - 1) * 1800)) {
            that.singleMoney = 1;
          } else {
            if (parseInt(that.yearCount) == 1) {
              that.singleMoney = equivalentYearMoney + parseInt(that.yearCount - 1) * 1800;
              if (that.buyVipType == '移动端月会员') {
                that.singleMoney = equivalentYearMoney + parseInt(that.yearCount - 1) * 1800 - that.equivalentMoney;
              }
            } else {
              that.singleMoney = equivalentYearMoney + parseInt(that.yearCount - 1) * 1800 - that.equivalentMoney;
              console.log('that.singleMoney:', that.singleMoney);
            }
          }
        } else if (parseInt(that.yearCount) >= 5) {
          //购买年会员账号数>=5
          if (that.buyVipType == '移动端月会员') {
            //月会员
            that.yearCountName = '升级';
          } else if (that.buyVipType == '专业年会员') {
            //3999年会员
            that.yearCountName = '升级';
          }
          if (that.equivalentMoney > that.singleMoneyApi + parseInt((that.yearCount - 1) * 1500)) {
            that.singleMoney = 1;
          } else {
            that.singleMoney = equivalentYearMoney + parseInt(that.yearCount - 1) * 1500 - that.equivalentMoney;
          }
        }
      } else {
        that.moneyCountShow = false;
      }
    },

    //购买多个月会员计算
    getMonthCount: function() {
      var that = this;
      if (that.monthCount.length > 0) {
        console.log('that.monthCount:', that.monthCount);
        if (that.monthCount % 1 !== 0) {
          that.$message({
            message: '请填写整数',
            type: 'warning'
          });
          that.monthCount = Math.round(that.monthCount);
        }
        if (parseInt(that.monthCount) > 36) {
          that.$message({
            message: '最大不能超过36个月',
            type: 'warning'
          });

          that.originalPriceShow = true;
          that.newMoney = Math.round(parseInt(that.monthCount) * that.moneyApi * 0.8).toFixed(2);
        } else if (parseInt(that.monthCount) < 1) {
          that.$message({
            message: '最小不能低于1个月',
            type: 'warning'
          });
          that.monthCount = 1;
          that.originalPriceShow = false;
          that.newMoney = parseInt(that.monthCount) * that.moneyApi;
        } else if (parseInt(that.monthCount) < 6) {
          that.newMoney = parseInt(that.monthCount) * that.moneyApi;
          that.originalPriceShow = false;
        } else if (parseInt(that.monthCount) >= 6 && parseInt(that.monthCount) < 12) {
          that.newMoney = Math.floor(parseInt(that.monthCount) * that.moneyApi * 0.9 * 100) / 100;
          that.originalPriceShow = true;
        } else if (parseInt(that.monthCount) >= 12) {
          that.newMoney = Math.floor(parseInt(that.monthCount) * that.moneyApi * 0.8 * 100) / 100;
          that.originalPriceShow = true;
        }
        that.oldMoney = parseInt(that.monthCount) * that.moneyApi;
      }
    },

    //获取续费会员信息(姓名、手机号码、公司名称)
    getActualMemberMsg: function() {
      var that = this;
      that.requestApi({
        method: 'get',
        url: '/api/member/getMember',
        then(data) {
          if (data.data != null) {
            that.memberName = data.data.username;
            that.memberPhone = data.data.phone;
            that.memberCompany = data.data.name;
          }
        }
      });
    },

    //vip会员-点击立即购买
    goVipPayWay: function() {
      var that = this;
      /* //验证姓名是否为空
      if (that.memberName == "") {
        that.$message({
          message: "请填写姓名",
          type: "warning"
        });
        return;
      }
      //验证手机号码是否为空、格式是否正确
      var reg = /^1\d{10}$/; //手机号正则验证
      var phoneNum = that.memberPhone;
      if (!phoneNum) {
        //未输入手机号
        that.$message({
          message: "请填写手机号码",
          type: "warning"
        });
        return;
      }
      if (!reg.test(phoneNum)) {
        //手机号不合法
        that.$message({
          message: "手机号码格式不正确",
          type: "error"
        });
        return;
      }
      //验证公司名称是否为空
      if (that.memberCompany == "") {
        that.$message({
          message: "请填写公司名称",
          type: "warning"
        });
        return;
      } */
      //第二步-支付信息-选择

      that.getVipWxPay(); //微信支付

      //套餐名字
    },

    //提交会员订单-微信支付
    getVipWxPay: function() {
      var that = this;
      var param; //提交的参数
      var vipUrl; //接口的链接
      console.log('提交会员订单-微信支付renewalFeeStatus:' + that.renewalFeeStatus);
      //that.renewalFeeStatus:false为正常的购买会员流程；true则为续费流程
      if (that.renewalFeeStatus == false) {
        vipUrl = '/api/member/member';
        if (that.typeId == 2) {
          //月会员
          if (that.monthCount > 1) {
            that.vipType = '月会员99/月/' + that.monthCount + '账号';
          } else {
            that.vipType = that.vipMemberName;
          }
        } else if (that.typeId == 9) {
          //年会员
          if (that.yearCount > 1) {
            that.vipType = '年会员3999/年/' + that.yearCount + '账号';
          } else {
            that.vipType = that.vipMemberName;
          }
        } else {
          that.vipType = that.vipMemberName;
        }
        param = {
          typeId: that.typeId, //套餐id
          companyName: that.memberCompany,
          name: that.memberName,
          phone: that.memberPhone,
          payType: 1, //1:微信支付
          number: that.typeId == 2 ? that.monthCount : 1, //移动端月会员提交月数，其他套餐提交"1
          memberNumber: that.typeId == 9 ? that.yearCount : 1 //3999年会员提交账号数，其他套餐提交1
        };
      } else {
        vipUrl = '/api/member/renew';
        if (that.vipLevelId == 2) {
          //月会员
          if (that.monthCount > 1) {
            that.vipType = '月会员99/月/' + that.monthCount + '账号';
          } else {
            that.vipType = that.vipMemberName;
          }
        } else if (that.vipLevelId == 9) {
          //年会员
          if (that.yearCount > 1) {
            that.vipType = '年会员3999/年/' + that.yearCount + '账号';
          } else {
            that.vipType = that.vipMemberName;
          }
        } else {
          that.vipType = that.vipMemberName;
        }
        param = {
          typeId: that.vipLevelId,
          number: that.vipLevelId == 2 ? that.monthCount : 1, //移动端月会员提交月数，其他套餐提交"1
          memberNumber: that.vipLevelId == 9 ? that.yearCount : 1 //3999年会员提交账号数，其他套餐提交1
        };
      }
      //提交会员订单
      that.requestApi({
        method: 'post',
        url: vipUrl,
        data: param,
        then(data) {
          if (data.code == 0) {
            that.vipPayWayLayoutShow = true;
            that.wxPayMoney = data.data.money;
            that.vipMoney = data.data.money;
            that.initQCode = data.data.codeUrl;
            that.merberOrderId = data.data.merberOrderId; //会员订单id--上传银行转账凭证时需要提交的订单id
            //每隔3秒根据二维码ticket查询扫描状态
            let ticketCode = data.data.outTradeNo; //后台返回的ticket
            that.timeValState = true;
            let timeVal = setInterval(() => {
              if (that.timeValState) {
                that.requestApi({
                  method: 'get',
                  url: '/api/getPayStatus',
                  data: {
                    outTradeNo: ticketCode
                  },
                  then(data) {
                    //1:已支付
                    if (data.data == 1) {
                      clearInterval(timeVal); //支付成功后将定时器停下
                      that.isShow = false;
                      that.timeValState = false;
                      //elementUI提供的提示框
                      that.$message({
                        message: '支付成功',
                        type: 'success'
                      });
                      setTimeout(() => {
                        that.vipTypeSelectLayoutShow = false;
                        that.vipPayWayLayoutShow = false;
                        window.location.reload(); //支付成功后刷新页面
                      }, 2000);
                    }
                    //2:支付失败
                    if (data.data == 2) {
                      that.$message({
                        message: '支付失败，请重新支付',
                        type: 'error'
                      });
                    }
                  },
                  fail(data) {
                    clearInterval(timeVal);
                  }
                });
              } else {
                clearInterval(timeVal);
              }
            }, 3000);
          }
        }
      });
    },

    //vip会员-取消
    cancelVipTypeSelect: function() {
      var that = this;
      that.vipTypeSelectLayoutShow = false;
      // that.closeCompanyAnalyzeBg(); //关闭企业分析背景图
      // that.closeTenderAnalyzeBg(); //关闭标讯分析背景图
    },

    //订单列表页面-点击的支付-提交会员订单-微信支付(只需提交订单id)
    getOrderVipWxPay: function() {
      var that = this;
      var param = {
        memberOrderId: that.merberOrderId
      };
      //提交会员订单
      that.requestApi({
        method: 'post',
        url: '/api/member/generatePayInfo',
        data: param,
        then(data) {
          if (data.code == 0) {
            that.vipPayWayLayoutShow = true; //支付信息弹窗
            that.wxPayMoney = data.data.money;
            that.initQCode = data.data.codeUrl;
            that.merberOrderId = data.data.merberOrderId; //会员订单id--上传银行转账凭证时需要提交的订单id
            //每隔3秒根据二维码ticket查询扫描状态
            let ticketCode = data.data.outTradeNo; //后台返回的ticket
            that.timeValState = true;
            let timeVal = setInterval(() => {
              if (that.timeValState) {
                that.requestApi({
                  method: 'get',
                  url: '/api/getPayStatus',
                  data: {
                    outTradeNo: ticketCode
                  },
                  then(data) {
                    //1:已支付
                    if (data.data == 1) {
                      clearInterval(timeVal); //支付成功后将定时器停下
                      that.isShow = false;
                      that.timeValState = false;
                      //elementUI提供的提示框
                      that.$message({
                        message: '支付成功',
                        type: 'success'
                      });
                      setTimeout(() => {
                        that.vipTypeSelectLayoutShow = false;
                        that.vipPayWayLayoutShow = false;
                        window.location.reload(); //支付成功后刷新页面
                      }, 2000);
                    }
                    //2:支付失败
                    if (data.data == 2) {
                      that.$message({
                        message: '支付失败，请重新支付',
                        type: 'error'
                      });
                    }
                  },
                  fail(data) {
                    clearInterval(timeVal);
                  }
                });
              } else {
                clearInterval(timeVal);
              }
            }, 3000);
          }
        }
      });
    },

    //支付信息-选择
    handleClick(tab) {
      var that = this;
      //选择-微信支付
      if (tab.name == 'first') {
        that.wxPayShow = true;
        that.bankTransferShow = false;
        console.log('微信支付：' + that.memberPhone);
      }
      //选择-银行转账
      if (tab.name == 'second') {
        that.wxPayShow = false;
        that.bankTransferShow = true;
      }
    },

    //支付信息-图片上传
    handleChange(file, fileList) {
      console.log(file);
      console.log(fileList);
      var that = this;
      that.imgList = fileList.slice(-1);
      that.imgUploadUrl = apiUrl + cntextPath + '/api/imgUpload?isThumb=false'; //银行转账-图片
    },

    //支付信息-图片上传成功
    uploadSuccess(response, file, fileList) {
      var that = this;
      console.log('that.imgUploadUuid:' + response.data);
      that.imgUploadUuid = response.data; //获取图片上传后返回的uuid
      that.$message({
        message: '支付凭证图片上传成功',
        type: 'success'
      });
    },

    //支付信息-图片上传失败
    uploadError(err, file, fileList) {
      var that = this;
      that.$message({
        message: '支付凭证图片上传失败，请重新上传',
        type: 'error'
      });
    },

    //支付信息-图片上传
    cancelVipPayWay: function() {
      var that = this;
      that.vipPayWayLayoutShow = false;
      that.timeValState = false;
      that.$emit('cancelVipPayWay');
    },

    //支付信息-图片上传-稍后上传
    goMyOrder: function() {
      var that = this;
      that.vipPayWayLayoutShow = false;
      that.$router.push({
        path: '/myOrder', //跳转的路由-我的订单
        query: {}
      });
    },

    //支付信息-银行转账-确定
    submitPay: function() {
      var that = this;
      console.log('银行转账-确定that.imgUploadUrl:' + that.imgUploadUrl);
      console.log('订单id：' + that.merberOrderId);
      if (that.imgUploadUrl != '') {
        that.requestApi({
          method: 'get',
          url: '/api/member/certificateImg',
          data: {
            memberOrderId: that.merberOrderId, //会员订单id--上传银行转账凭证时需要提交的订单id
            certificateImg: that.imgUploadUuid //图片上传成功后返回的uuid
          },
          then(data) {
            that.$message({
              message: '提交成功',
              type: 'success'
            });
            that.imgUploadSuccessShow = true;
            that.uploadBtnShow = false; //点击上传按钮-隐藏
            that.imgUploadFailShow = false; //银行转账-支付凭证审核不通过提示是否显示
            that.layButtonShow = false;
            // setTimeout(() => {
            //   that.vipTypeSelectLayoutShow = false;
            //   that.vipPayWayLayoutShow = false;
            // }, 2000);
          }
        });
      } else {
        that.$message({
          message: '请上传支付凭证图片',
          type: 'warning'
        });
      }
      that.$emit('submitPay');
    },

    //获取会员审核(银行转账图片)不通过的原因
    getErrorMsg: function() {
      var that = this;
      console.log('获取会员审核(银行转账图片)不通过的原因:' + that.merberOrderId);
      that.requestApi({
        method: 'get',
        url: '/api/member/order/getMemberOrder',
        data: {
          orderId: that.merberOrderId
        },
        then(data) {
          if (data.data != null) {
            that.imgUploadFailMsg = data.data.errorInfo;
          }
        }
      });
    },

    //打开vip会员弹窗
    openVipTypeSelect: function() {
      this.activity = true;
      var that = this;
      console.log('vip会员弹窗that.renewalFeeStatus:' + that.renewalFeeStatus);
      that.payWayActive = 'first';
      that.getVipTypeList(); //获取vip类型列表
      that.vipTypeSelectLayoutShow = true;
      that.layButtonShow = true; //银行转账-操作按钮的显示状态（支付凭证上传成功后处于审核状态将该按钮隐藏）
    },

    //打开vip会员续费弹窗
    openVipRenewalFee: function(renewalFeeStatus) {
      var that = this;
      that.payWayActive = 'first';
      // that.renewalFeeStatus = renewalFeeStatus;
      console.log('vip会员续费弹窗that.renewalFeeStatus:' + that.renewalFeeStatus);
      that.getVipTypeList(); //获取vip类型列表
      that.vipTypeSelectLayoutShow = true;
      that.layButtonShow = true; //银行转账-操作按钮的显示状态（支付凭证上传成功后处于审核状态将该按钮隐藏）
    },

    //会员的状态--待支付
    memberWaitingPay: function(merberOrderId, vipTypeName, payMoney) {
      var that = this;
      console.log('vipTypeName:', vipTypeName);
      that.uploadBtnShow = true;
      that.payWayActive = 'first';
      that.vipType = vipTypeName;
      that.vipMoney = payMoney;
      console.log('vipBuy会员的状态--待支付:' + merberOrderId);
      that.merberOrderId = merberOrderId;
      that.pageTabNavShow = true; //支付信息-微信支付、银行转账切换导航的状态
      //that.vipPayWayLayoutShow = true; //支付信息弹窗
      that.payVoucherTips = '请上传支付凭证图片';
      that.wxPayShow = true; //微信支付隐藏
      that.bankTransferShow = false; //银行转账显示
      that.imgUploadSuccessShow = false; //银行转账-支付凭证待审核提示是否显示
      that.imgUploadFailShow = false; //银行转账-支付凭证审核不通过提示是否显示
      that.layButtonShow = true; //银行转账-操作按钮的显示状态（支付凭证上传成功后处于审核状态将该按钮隐藏）
      that.getOrderVipWxPay(); //订单列表页面-点击的支付-提交会员订单-微信支付(只需提交订单id)
    },

    //会员的状态--待上传支付凭证
    upLoadBankImg: function(merberOrderId, vipTypeName, payMoney) {
      var that = this;
      that.merberOrderId = merberOrderId;
      that.vipType = vipTypeName;
      that.vipMoney = payMoney;
      that.uploadBtnShow = true;
      that.pageTabNavShow = false; //支付信息-微信支付、银行转账切换导航的状态
      that.wxPayShow = false; //微信支付隐藏
      that.imgUploadSuccessShow = false; //银行转账-支付凭证待审核提示是否显示
      that.imgUploadFailShow = false; //银行转账-支付凭证审核不通过提示是否显示
      that.vipPayWayLayoutShow = true; //支付信息弹窗
      that.payVoucherTips = '请上传支付凭证图片';
      that.bankTransferShow = true; //银行转账显示
      that.layButtonShow = true; //银行转账-操作按钮的显示状态（支付凭证上传成功后处于审核状态将该按钮隐藏）
    },

    //会员的状态--待审核会员
    memberReviewing: function(vipTypeName, payMoney) {
      var that = this;
      that.vipType = vipTypeName;
      that.vipMoney = payMoney;
      that.pageTabNavShow = false; //支付信息-微信支付、银行转账切换导航的状态
      that.wxPayShow = false; //微信支付隐藏
      that.vipPayWayLayoutShow = true; //支付信息弹窗
      that.payVoucherTips = '支付凭证已上传成功';
      that.bankTransferShow = true; //银行转账显示
      that.imgUploadSuccessShow = true; //银行转账-支付凭证待审核提示是否显示
      that.imgUploadFailShow = false; //银行转账-支付凭证审核不通过提示是否显示
      that.layButtonShow = false; //银行转账-操作按钮的显示状态（支付凭证上传成功后处于审核状态将该按钮隐藏）
      that.uploadBtnShow = false;
    },

    //会员的状态--会员审核不通过
    memberFail: function(merberOrderId, vipTypeName, payMoney) {
      var that = this;
      that.merberOrderId = merberOrderId;
      that.vipType = vipTypeName;
      that.vipMoney = payMoney;
      that.uploadBtnShow = true;
      console.log('vipBuy会员的状态--待支付:' + that.merberOrderId);
      that.pageTabNavShow = false; //支付信息-微信支付、银行转账切换导航的状态
      that.wxPayShow = false; //微信支付隐藏
      that.vipPayWayLayoutShow = true; //支付信息弹窗
      that.payVoucherTips = '请重新上传支付凭证图片';
      that.bankTransferShow = true; //银行转账显示
      that.imgUploadSuccessShow = false; //银行转账-支付凭证待审核提示是否显示
      that.imgUploadFailShow = true; //银行转账-支付凭证审核不通过提示是否显示
      that.layButtonShow = true; //银行转账-操作按钮的显示状态（支付凭证上传成功后处于审核状态将该按钮隐藏）
      that.cancelBtnText = '取消';
      that.imgUploadFailShow = true; //银行转账-支付凭证审核不通过提示是否显示
      that.getErrorMsg(); //获取会员审核(银行转账图片)不通过的原因
    },

    //打开企业分析背景图（非会员点击企业分析时显示）
    openCompanyAnalyzeBg: function() {
      var that = this;
      that.companyAnalyzeBgShow = true;
    },

    //关闭企业分析背景图
    closeCompanyAnalyzeBg: function() {
      var that = this;
      that.companyAnalyzeBgShow = false;
    },

    //打开标讯分析背景图
    openTenderAnalyzeBg: function() {
      var that = this;
      that.tenderAnalyzeBgShow = true;
    },

    //关闭标讯分析背景图
    closeTenderAnalyzeBg: function() {
      var that = this;
      that.tenderAnalyzeBgShow = false;
    }
  },

  /**
   * 模板渲染成html后调用
   */
  mounted() {
    var that = this;
    that.isMemberVip(); //判断是否为vip会员（包含移动端月会员）
    console.log('银行转账apiUrl:' + apiUrl);
    console.log('银行转账that.imgUploadUrl:' + that.imgUploadUrl);
    that.imgUploadUrl = apiUrl + cntextPath + '/api/imgUpload?isThumb=false'; //银行转账-图片
    that.getActualMemberMsg(); //获取续费会员信息(姓名、手机号码、公司名称)
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* 活动结束全删除 */
.notice {
  display: flex;
  font-size: 20rpx;
}
.notice > div:nth-child(1) {
 position: absolute;
 z-index: 9;
 width: 65%;
 background-color: #fff;
 left: 15%;
 margin: 10rpx;
 height: 518rpx;
 box-shadow: rgba(0, 0, 0, 0.35) 0px 5rpx 15rpx;
}
.imgClass{
  display: flex;
  align-items: center;
  justify-content: center;
}
/* .vipTypeSelectLayout .content{
      width: 800rpx;
      height: 490rpx;
} */
ul li{
  padding: 3rpx 0;
}
.vipTypeSelectLayout .vipUseTable tbody td{
  background: #FEFAF3 !important;
}

.fullimgbox{
  position: fixed;
  width: 100vw;
  height: 100vh;
  top:0;
  left:0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 2000;
}
.fullimg{
    max-width: 1500px;
    min-width: 800px;
    width: 1035px;
    margin-top: 60px;
    width: 100%;
  }
  .close{
    top: 20px;
    width: 24px;
    position: absolute;
    right: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/page/vipMember/vipBuy.vue